import { Home } from "lucide-react";
import { UserTypes, SYSTEM_USER_RIGHTS } from "@/configs/AppConfig";

export const system_user_api_prefix = "/admapi";
export const patient_api_prefix = "/api";

const combine = (...strings) => {
  return strings.filter(Boolean).join("");
};

export class MOD_AUTH {
  static id = "patient-auth";
  static login_path = "/log-in";
  static register_path = "/register";
  static forgot_password_path = "/forgot-password";
  static default_log_in_path = this.login_path;
  static default_path_when_logged_in = "/hair-assessment";
  static auth = [UserTypes.GUEST];
  static api_base = combine(patient_api_prefix, "/appUserProfileOperations");
  static api = {
    auth: combine(this.api_base, "/auth"),
    logout: combine(this.api_base, "/logout"),
    getOTP: combine(this.api_base, "/getOTP"),
    reloadRights: combine(this.api_base, "/reloadRights"),
    register: combine(this.api_base, "/register"),
  };
}

export class MOD_GENDER {
  static id = "gender";
  static name = "Gender";
  static base_path = "/gender";
  static base_api = combine(patient_api_prefix, "/employees");
  static api = {
    selectList: combine(this.base_api, "/selectGenderList"),
  };
}
export class MOD_CITY {
  static id = "city";
  static name = "City";
  static base_path = "/city";
  static base_api = combine(patient_api_prefix, "/cities");
  static api = {
    selectList: combine(this.base_api, "/selectListV2"),
  };
}

export class MOD_ATTACHMENT {
  static id = "attachment";
  static base_api = combine(
    patient_api_prefix,
    "/systemPreliminaryAttachments",
  );
  static api = {
    upload: this.base_api,
  };
}

// MODULES

export class MOD_HAIR_ASSESSMENT {
  static id = "hair-assessment";
  static base_path = "/hair-assessment";
  static route_id = "/:hairAssessmentId";
  static base_api = combine(
    patient_api_prefix,
    "/appPatientUserOperations/assessment",
  );
  static name = "Hair Assessment";
  static name_plural = "Hair Assessments";
  static icon = (<Home />);
  static auth = [UserTypes.PATIENT];
  static right = "";
  static routes = {
    detail: combine(this.base_path, "/detail"),
    form: combine(this.base_path, "/form"),
  };
  static api = {
    form_preload: combine(this.base_api, "/assessmentForm", "/preload"),
    subtypeSelectList: combine(
      this.base_api,
      "/assessmentSubTypes",
      "/selectList",
    ),
    detail: combine(this.base_api, "/assessmentFormResponses", "/detail"),
    preload: combine(this.base_api, "/assessmentFormResponses", "/preload"),
    summary: combine(this.base_api, "/assessmentFormResponses", "/summary"),
    save: combine(this.base_api, "/assessmentFormResponses"),
  };
}
